import { render, staticRenderFns } from "./TicketsReportWhatsapp.vue?vue&type=template&id=2736cd95"
import script from "./TicketsReportWhatsapp.vue?vue&type=script&lang=js"
export * from "./TicketsReportWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports